import { render, staticRenderFns } from "./CollectorComponents.vue?vue&type=template&id=55ebcdda&scoped=true&"
import script from "./CollectorComponents.vue?vue&type=script&lang=js&"
export * from "./CollectorComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ebcdda",
  null
  
)

export default component.exports